import React from 'react';
import * as R from 'ramda';
import { createUseStyles } from 'features/sharedModules/styles/components/styles.js';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router';

import { i18n } from 'i18n/index.js';
import SavingRoboLooking from 'assets/saving-robo-icons/looking.js';
import { getSavingGoalsNextRouteConfig } from 'features/shared/services/router/selectors.js';
import { usePrevRoute } from 'features/sharedModules/router/components/usePrevRoute.js';
import { useNextRoute } from 'features/sharedModules/router/components/useNextRoute.js';
import sessionSelectors from 'features/shared/services/session/selectors.js';
import userOptionsSelectors from 'features/shared/services/userOptions/selectors.js';
import { creators as userOptionsCreator } from 'features/shared/services/userOptions/actions.js';
import List from 'features/shared/components/list/index.js';
import Button, { ButtonType } from 'features/shared/components/button/index';
import Navigation from 'features/shared/components/screenLayout/navigation';
import { TextFontSizes } from 'features/shared/constants/fonts.js';
import Layout from 'features/shared/components/screenLayout/layout.js';
import Page from 'features/shared/components/screenLayout/page.js';
import Footer from 'features/shared/components/screenLayout/footer.js';
import { Colors } from 'features/shared/constants/colors.js';

const useStyles = createUseStyles(theme => ({
  subTitle: {
    fontFamily: theme.subTitleFontFamily,
    fontSize: TextFontSizes.largePx,
    lineHeight: TextFontSizes.largeLineHeightPx,
    textAlign: 'center',
    paddingTop: '15px',
    color: Colors.grayDark
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  contentHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '40px',
    paddingTop: '50px'
  }
}));

const SavingGoals = () => {
  const classes = useStyles();
  const history = useHistory();
  const { customerId } = useParams();

  const prevRoute = usePrevRoute();
  const nextRoute = useNextRoute(getSavingGoalsNextRouteConfig);

  const translations = useSelector(sessionSelectors.getTranslationsConfig);
  const goals = useSelector(sessionSelectors.getGoalsConfig);
  const userOptions = useSelector(userOptionsSelectors.getUserOptions);
  const reportConfig = useSelector(sessionSelectors.getReportConfig);

  const dispatch = useDispatch();
  const userGoalSelected = item => {
    const value = {
      id: item.id,
      title: i18n(item.title, translations),
      icon: item.icon
    };
    dispatch(userOptionsCreator.savingGoalOptionChanged({ value }));
  };

  return (
    <Layout>
      <Navigation prevRoute={prevRoute} customerId={customerId}>
        {i18n('goal.naviTitle', translations)}
      </Navigation>

      <Page>
        <div className={classes.content}>
          <div className={classes.contentHeader}>
            <SavingRoboLooking />
            <span className={classes.subTitle}>
              {i18n('goal.subTitle', translations)}
            </span>
          </div>

          <List
            options={goals}
            selectedOption={userOptions.goal.id}
            onSelect={(type, item) => {
              userGoalSelected(item);
              window.scrollTo(0, document.body.scrollHeight);
            }}
            showIcons={reportConfig?.showGoalIcons}
          />
        </div>

        <Footer>
          {nextRoute && (
            <Button
              type={ButtonType.primary}
              disabled={R.isEmpty(userOptions.goal.id)}
              onClick={() => {
                history.push(nextRoute.build(customerId));
              }}
            >
              {i18n('shared.continue', translations)}
            </Button>
          )}
        </Footer>
      </Page>
    </Layout>
  );
};

export default SavingGoals;
